export const degrees = [
    {
      value: "STUDENT",
      label: "دانش آموز",
    },
    {
      value: "DIPLOMA",
      label: "دیپلم",
    },
    {
      value: "ASSOCIATE",
      label: "دانشجو",
    },
    {
      value: "BACHELOR",
      label: "کارشناسی",
    },
    {
      value: "MASTER",
      label: "کارشناسی ارشد",
    },
    {
      value: "DOCTORAL",
      label: "دکتری",
    },
  ]
